import React, { FC } from 'react';
import InsertDriveFileOutlinedIcon from '@mui/icons-material//InsertDriveFileOutlined';
import { Box, Typography } from '@mui/material';
import { NO_TASKS } from 'common/constants/firms';
import { DOCUMENT_REQUEST_CATEGORY, QUESTIONNAIRE_REQUEST_CATEGORY } from 'common/constants/process-management';
import { Task } from 'common/types/firm';
import { CustomTaskBox } from 'pages/Funds/components/ProcessManagement/CustomTaskBox';
import { ProcessManagementTask } from 'pages/Funds/components/ProcessManagement/CustomTaskBox/types';
import { dbShortDate, ISO_DATE_FORMAT } from 'utilities/dateFormats';
import { TaskCellProps } from './types';

const normalizeMeasurementDateName = (measurementDateName?: string) =>
  dbShortDate(measurementDateName, ISO_DATE_FORMAT) ?? measurementDateName ?? '';

const NoTasksMessage = () => (
  <Box display="flex" justifyContent="center">
    <Typography variant="body2">{NO_TASKS}</Typography>
  </Box>
);

const createTask = (task: Task | undefined): ProcessManagementTask | undefined => {
  if (!task?.progress) {
    return undefined;
  }

  return {
    id: task.id ?? 0,
    summary: task.summary ?? '',
    progress: task.progress,
  };
};

const TaskCell: FC<TaskCellProps> = ({
  cellKey,
  companySlug,
  companyName,
  fundName,
  measurementDateName,
  tasksProgress,
  onTaskClick,
}) => {
  const company = tasksProgress?.companies?.find(c => c.name === companyName);
  const normalizedMeasurementDateName = normalizeMeasurementDateName(measurementDateName);
  const measurementDate = company?.company_measurement_dates?.find(
    md => normalizeMeasurementDateName(md.measurement_date?.name) === normalizedMeasurementDateName
  );

  if (!measurementDate?.tasks?.length) {
    return <NoTasksMessage />;
  }

  const { tasks } = measurementDate;
  const documentTask = tasks.find(t => Number(t.category) === Number(DOCUMENT_REQUEST_CATEGORY));
  const questionnaireTask = tasks.find(t => Number(t.category) === Number(QUESTIONNAIRE_REQUEST_CATEGORY));

  const latestDocumentTask = createTask(documentTask);
  const latestQuestionnaireTask = createTask(questionnaireTask);

  if (!latestDocumentTask && !latestQuestionnaireTask) {
    return <NoTasksMessage />;
  }

  return (
    <Box display="flex" justifyContent="center">
      {latestDocumentTask && (
        <CustomTaskBox
          cellKey={cellKey}
          companyName={companyName}
          fundName={fundName}
          measurementDateName={measurementDateName}
          task={latestDocumentTask}
          companySlug={companySlug}
          isDocuments
          onTaskClick={onTaskClick}>
          <InsertDriveFileOutlinedIcon />
        </CustomTaskBox>
      )}
      {latestQuestionnaireTask && (
        <CustomTaskBox
          cellKey={cellKey}
          companyName={companyName}
          fundName={fundName}
          measurementDateName={measurementDateName}
          task={latestQuestionnaireTask}
          companySlug={companySlug}
          onTaskClick={onTaskClick}>
          ?
        </CustomTaskBox>
      )}
    </Box>
  );
};

export default TaskCell;
